import { c as _c } from "react/compiler-runtime";
import { graphql, readFragment } from "@opensea/graphql";
import { NumberDisplay, QuantityBadge, TextLabel, Tooltip } from "@opensea/ui-kit";
import { useTranslations } from "next-intl";
import { getItemOwnedQuantity, ItemOwnedQuantityFragment } from "./utils";
export const OwnedQuantityFragment = graphql(`
    fragment OwnedQuantity on Item {
      ...ItemOwnedQuantity
    }
  `, [ItemOwnedQuantityFragment]);
export function OwnedQuantityBadge(t0) {
  const $ = _c(13);
  const {
    item: itemKey,
    iconSize,
    className
  } = t0;
  const item = readFragment(OwnedQuantityFragment, itemKey);
  const ownedQuantity = getItemOwnedQuantity(item);
  const t = useTranslations("OwnedQuantityBadge");
  if (ownedQuantity.lte(0)) {
    return null;
  }
  const T0 = Tooltip;
  const T1 = TextLabel;
  const t1 = t("owned", {
    count: ownedQuantity.toString()
  });
  let t2;
  if ($[0] !== T1 || $[1] !== t1) {
    t2 = <T1>{t1}</T1>;
    $[0] = T1;
    $[1] = t1;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== ownedQuantity) {
    t3 = <NumberDisplay display="quantity" value={ownedQuantity} />;
    $[3] = ownedQuantity;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== className || $[6] !== iconSize || $[7] !== t3) {
    t4 = <QuantityBadge className={className} iconSize={iconSize}>{t3}</QuantityBadge>;
    $[5] = className;
    $[6] = iconSize;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== T0 || $[10] !== t2 || $[11] !== t4) {
    t5 = <T0 content={t2}>{t4}</T0>;
    $[9] = T0;
    $[10] = t2;
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  return t5;
}